export default __webpack_public_path__ + "static/media/map.eb647253.png";